<template>
    <main>
        <transition-group appear name="fade">
        <div v-for="(hint, index) in hints" :key="hint.text + index">
            <Hint :hint="hint" :show="hint.show"/>
        </div>
        </transition-group>
    </main>
</template>

<script>
import Hints from '@/models/hints'
import Hint from './Hint'

import { mapGetters } from "vuex"

export default {
    name: "HintCanvas",
    components: {
        Hint
    },
    computed: {
        ...mapGetters({
            "hints" : "hints/hints",
        }),
    },
    methods: {
        // updateHints(){
        //     console.log("update!")
        //     this.hints = null;
        //     this.hints = Hints.getAll();
        // },
        exists(hint){
            return hint.start && hint.end;
        }
    },
    mounted(){
        //window.addEventListener('resize', this.updateHints);

        // setTimeout(() => {
        //     this.updateHints();
        // }, 1000);
    }

}
</script>